import React from "react";

import { CardActions } from "@material-ui/core/";

import { withStyles } from "@material-ui/core";

import { CardActionsStyles } from "../styles/";

const CardActionsComponent = (props) => (
  <CardActions className={props.classes.root}>{props.children}</CardActions>
);

export default withStyles(CardActionsStyles)(CardActionsComponent);
